'use es6';

import { useState } from 'react';
import styled from 'styled-components';
import { colors } from '../../theming/themes/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledAccordion = styled.div.withConfig({
  displayName: "Accordion__StyledAccordion",
  componentId: "sc-1v6gizx-0"
})(["border-bottom:1px solid ", ";margin-bottom:1.2rem;padding-bottom:1.1rem;padding-right:0.5rem;h3{line-height:20px;margin-bottom:0;}.question{position:relative;font-size:1.1rem;font-weight:600;cursor:pointer;}.question::after{transform:", ";border-style:solid;border-width:1px 1px 0 0;content:' ';display:inline-block;float:right;height:10px;left:2px;position:relative;right:20px;top:2px;transition:0.25s ease-in-out;vertical-align:top;width:10px;}.answer{display:", ";overflow-wrap:break-word;padding-top:1rem;padding-right:1.25rem;line-height:1.5;transition:3.35s ease-in-out;}"], colors.PRIMARYWHITE, props => props.open ? 'rotate(-45deg)' : 'rotate(135deg)', props => props.open ? 'inline-block' : 'none');
const Accordion = ({
  question,
  answer
}) => {
  const [open, setOpen] = useState(false);
  const handleClick = e => {
    e.stopPropagation();
    setOpen(!open);
  };
  return /*#__PURE__*/_jsxs(StyledAccordion, {
    open: open,
    onClick: handleClick,
    children: [/*#__PURE__*/_jsx("h3", {
      className: "question",
      children: question
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx("article", {
        className: "answer",
        children: answer
      })
    })]
  });
};
export default Accordion;